import * as apicall from "../components/Apicall";

export const getCampaigns = (filters = {}) =>
  apicall.post(filters, "ezp_get_all_customer_campaigns");

export const getCampaignDetail = (id) =>
  apicall.get(`ezp_customer_campaign/${id}`);

export const getCampaignReport = (id, { page = 1, limit = 50 } = {}) =>
  apicall.get(`ezp_customer_campaign/report/${id}?page=${page}&limit=${limit}`);

export const saveCampaign = (data) =>
  apicall.post(data, "ezp_customer_campaign");

export const getAudiencePreviewCount = () =>
  apicall.post({}, "ezp_customer_campaign/audience_preview");

export const uploadAudienceFile = (data) =>
  apicall.post(data, "ezp_customer_campaign/upload_audience_file");

export const sendCampaignNow = (campaign_id) =>
  apicall.post({ campaign_id }, "ezp_customer_campaign/send_now");

export const scheduleCampaign = (data) =>
  apicall.post(data, "ezp_customer_campaign/schedule");

export const cancelCampaign = (id) =>
  apicall.get(`ezp_customer_campaign/cancel/${id}`);

export const deleteCampaign = (id) =>
  apicall.get(`ezp_customer_campaign/delete/${id}`);

// Reuses the existing, already-live WhatsApp template endpoint from the
// Channels feature (src/routes/chat) — not part of this feature's new API surface.
export const getVendorTemplates = () => apicall.get("getVendorTemplates");
